var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3974 9.87982L10.8074 5.28982C10.62 5.10356 10.3665 4.99902 10.1024 4.99902C9.83818 4.99902 9.58472 5.10356 9.39736 5.28982C9.30363 5.38278 9.22924 5.49338 9.17847 5.61524C9.1277 5.7371 9.10156 5.8678 9.10156 5.99982C9.10156 6.13183 9.1277 6.26253 9.17847 6.38439C9.22924 6.50625 9.30363 6.61685 9.39736 6.70982L13.9974 11.2898C14.0911 11.3828 14.1655 11.4934 14.2163 11.6152C14.267 11.7371 14.2932 11.8678 14.2932 11.9998C14.2932 12.1318 14.267 12.2625 14.2163 12.3844C14.1655 12.5063 14.0911 12.6169 13.9974 12.7098L9.39736 17.2898C9.20906 17.4768 9.10274 17.7309 9.1018 17.9963C9.10087 18.2616 9.20538 18.5165 9.39236 18.7048C9.57934 18.8931 9.83346 18.9994 10.0988 19.0004C10.3642 19.0013 10.6191 18.8968 10.8074 18.7098L15.3974 14.1198C15.9592 13.5573 16.2747 12.7948 16.2747 11.9998C16.2747 11.2048 15.9592 10.4423 15.3974 9.87982V9.87982Z",
    fill: "#0B1014"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.2523f391d4dd805ad2a86902ed50161b.svg";
export { ForwardRef as ReactComponent };